import styled from "styled-components";

export const MissionItemContainer = styled.div<{ isOpen?: boolean }>`
  width: 100%;
  padding: 16px 32px;
  border-bottom: 1px #e9e9e9 solid;
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: background 0.2s;
  background: ${({ isOpen }) => (isOpen ? "rgba(85, 184, 179, 0.10)" : "none")};
  position: relative;
  &:hover {
    background: ${({ isOpen }) =>
      isOpen ? "rgba(85, 184, 179, 0.10)" : "#f4f4f4"};
  }
`;

export const MissionItemHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const MissionItemContent = styled.div`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const MissionName = styled.span`
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  word-wrap: break-word;
`;

export const MissionInfoContainer = styled.div`
  display: flex;
  gap: 16px;
`;

export const DeploymentInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DeploymentInfo = styled.div`
  display: block;
`;

export const DeploymentLabel = styled.span`
  color: #606060;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;
  word-wrap: break-word;
`;

export const DeploymentTime = styled.span`
  color: #1b1b1b;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;
  word-wrap: break-word;
`;

export const DeployButton = styled.button`
  height: 48px;
  padding: 16px;
  outline: 2px #3f7f7d solid;
  outline-offset: -2px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
`;

export const ExpandButton = styled.button`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 1px solid #d1d1d1;
  outline-offset: -1px;
  background: none;
  border: none;
  cursor: pointer;
  transition: outline-color 0.2s, outline-width 0.2s;
  &:focus,
  &:active {
    outline: 1px solid #d1d1d1;
    outline-offset: -1px;
  }
`;

export const DeployIconContainer = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ExpandIconContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DeployButtonContent = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: flex;
`;

export const DeployText = styled.span`
  color: #3f7f7d;
  font-size: 18px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
`;

// Modal Styles
// Offset below the mission header row; width wide enough for the vehicle picker form
const DEPLOY_MODAL_OFFSET_PX = 50;
const DEPLOY_MODAL_WIDTH_PX = 600;

export const DeployModalContent = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%) translateY(${DEPLOY_MODAL_OFFSET_PX}px);
  z-index: 9999;
  background: #ffffff;
  border-radius: 4px;
  width: ${DEPLOY_MODAL_WIDTH_PX}px;
  box-shadow: 0px 4px 12px rgba(27, 27, 27, 0.1);
  border: 1px solid #d1d1d1;
  display: flex;
  flex-direction: column;
`;

export const DeployModalBody = styled.div`
  padding: 16px 32px;
  flex: 1;
`;

export const DeployModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 32px 24px 32px;
  border-top: 1px solid #f4f4f4;

  button {
    padding: 12px 16px;
    border-radius: 0;
    font-size: 20px;
    font-family: Readex Pro;
    font-weight: 400;
    line-height: 24px;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    outline: 2px solid;
    outline-offset: -2px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;

    &:first-child {
      background: #ffffff;
      color: #1b1b1b;
      outline-color: #d1d1d1;

      &:hover {
        background: #f4f4f4;
      }
    }

    &:last-child {
      background: #ffffff;
      color: #3f7f7d;
      outline-color: #3f7f7d;

      &:hover:not(:disabled) {
        background: #f4f4f4;
      }

      &:disabled {
        background: #d1d1d1;
        outline-color: #d1d1d1;
        color: #606060;
        cursor: not-allowed;
      }
    }
  }
`;

export const ConfirmModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
`;
